import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const fetchPlayers = async ({ division, search, minScore, maxScore } = {}) => {
    const params = {};
    if (division) params.division = division;
    if (search) params.search = search;
    if (minScore !== undefined && minScore !== null && minScore !== "") params.min_score = minScore;
    if (maxScore !== undefined && maxScore !== null && maxScore !== "") params.max_score = maxScore;
    const { data } = await api.get("/players", { params });
    return data;
};

export const fetchStats = async () => {
    const { data } = await api.get("/tournament/stats");
    return data;
};
